<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/unmapmatch")
          i.fas.fa-unlink
          span.ml-1 {{ $t("ui.unmap_list") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="unmapMatchSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-2.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $t("ui.match_id") }}
                    b-form-radio(value="name") {{ $t("ui.league_name") }}
          div.row
            div.col-md-12.mb-1
              div.form-row
                //- div.col-md-2.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.far.fa-clock
                //-     b-form-select(v-model="marketType" @change="marketOnChange($event)")
                //-       option(value="") {{ $t('ui.all') }}
                //-       option(value="early") {{ $t('ui.early') }}
                //-       option(value="today") {{ $t('ui.today') }}
                //-       option(value="live") {{ $t("ui.live") }}
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="sortKey")
                //-       option(value="match_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="league_name") {{ $tc("ui.leagues", 1) }}
                //-       option(value="match_date_time") {{ $t("ui.match_datetime") }}
                //-     b-form-select(v-model="sortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getUnmapMatchList(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="unmapMatchTotalRow"
                  :per-page="getPageSize"
                  v-model="currentUnmapMatchPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                  b-input(:value="unmapMatchTotalRow" readonly)
            div.row.clusterize
              div.col-md-12.clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width=100 @click="sortOrder('match_id')")
                        span {{ $t('ui.id') }}
                        i(:class="changeSortKey('match_id')")
                      th.sticky-position(width=80)
                        span(:title="$t('ui.match_provider')") {{ $t('ui.short.match_provider') }}
                      th.sticky-position(width=80 @click="sortOrder('sport_type')")
                        span {{ $tc('ui.sports', 1) }}
                        i(:class="changeSortKey('sport_type')")
                      th.sticky-position(@click="sortOrder('league_name')")
                        span {{ $tc("ui.leagues", 1) }}
                        i(:class="changeSortKey('league_name')")
                      th.sticky-position(width=100)
                        span(:title="$t('ui.league_provider')") {{ $t("ui.short.league_provider") }}
                      th.sticky-position(width=200)
                        span {{ $t("ui.home") }}
                      th.sticky-position(width=100)
                        span(:title="$t('ui.home_provider')") {{ $t("ui.short.home_provider") }}
                      th.sticky-position(width=200)
                        span {{ $t("ui.away") }}
                      th.sticky-position(width=100)
                        span(:title="$t('ui.away_provider')") {{ $t("ui.short.away_provider") }}
                      //- th.sticky-position(width=80)
                      //-   span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                      th.sticky-position(width=80 @click="sortOrder('match_date_time')")
                        span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                        i(:class="changeSortKey('match_date_time')")
                      th.sticky-position(width=80)
                        span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                  tbody.clusterize-content
                    tr(v-if="unmapMatchList.length == 0")
                      td(colspan="11").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in unmapMatchList")
                      td
                        span {{ item.match_id }}
                      td
                        span {{ item.provider_id }}
                      td
                        span {{ item.sport_type }}
                      td
                        span(:title="item.league_name") {{ item.league_name }}
                      td
                        span {{ getLeagueProvider(item) }}
                      td
                        span(:title="item.home_team") {{ item.home_team }}
                      td
                        span {{ getHomeTeamProvider(item) }}
                      td
                        span(:title="item.away_team") {{ item.away_team }}
                      td
                        span {{ getAwayTeamProvider(item) }}
                      //- td.text-uppercase
                      //-   span {{ item.market_type }}
                      td
                        span {{ getDate(item.match_date) }}
                      td
                        span {{ item.match_time }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { lchownSync } from 'fs';

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    matchInfo: null,
    sportType: 1,
    sportList: [],
    unmapMatchList: [],
    currentUnmapMatchPage: 1,
    unmapMatchTotalRow: 0,
    unmapMatchSearch: "",
    marketType: "",
    sortKey: "league_name",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    filterBy: "name"
  }),
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWD() {
      return this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD');
    },
    tomorrowWD() {
      return this.$moment(new Date).add(1, 'days').add(-12, 'hours').format('YYYY-MM-DD');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    }
  },
  mounted: function() {
    this.getSportList();
    this.startDate = this.yesterday;
    this.endDate = this.today;
  },
  methods: {
    marketOnChange(eventStatus) {
      if (eventStatus == '') {
        this.startDate = this.yesterday;
        this.endDate = this.today;
      }
      else if (eventStatus == 'early') {
        this.startDate = this.tomorrowWD;
        this.endDate = this.tomorrowWD;
      } else if (eventStatus == 'today' || eventStatus == 'live') {
        this.startDate = this.todayWD;
        this.endDate = this.todayWD;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getUnmapMatchList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getLeagueProvider(item) {
      var lnStr = '';

      if (item.ln_sbo)
        lnStr += lnStr.length > 0 ? ', SBO' : 'SBO';
      if (item.ln_ibc)
        lnStr += lnStr.length > 0 ? ', IBC' : 'IBC';
      if (item.ln_cmd)
        lnStr += lnStr.length > 0 ? ', CMD' : 'CMD';

      return lnStr;
    },
    getHomeTeamProvider(item) {
      var lnStr = '';

      if (item.th_sbo)
        lnStr += lnStr.length > 0 ? ', SBO' : 'SBO';
      if (item.th_ibc)
        lnStr += lnStr.length > 0 ? ', IBC' : 'IBC';
      if (item.th_cmd)
        lnStr += lnStr.length > 0 ? ', CMD' : 'CMD';

      return lnStr;
    },
    getAwayTeamProvider(item) {
      var lnStr = '';

      if (item.ta_sbo)
        lnStr += lnStr.length > 0 ? ', SBO' : 'SBO';
      if (item.ta_ibc)
        lnStr += lnStr.length > 0 ? ', IBC' : 'IBC';
      if (item.ta_cmd)
        lnStr += lnStr.length > 0 ? ', CMD' : 'CMD';

      return lnStr;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.unmapmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getUnmapMatchList: function(isSearch) {
      let url = config.unmapMatchListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentUnmapMatchPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.unmapmatch,
        sport_id: this.sportType,
        league_name: this.unmapMatchSearch,
        market_type: this.marketType,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentUnmapMatchPage,
        page_size: this.getPageSize
      };

      if (this.filterBy == "id") {
        json.match_id = this.unmapMatchSearch;
      } else {
        json.league_name = this.unmapMatchSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.unmapMatchList = response.data.tbl_unmap_match_list;
                this.unmapMatchTotalRow = this.unmapMatchList.length > 0 ? this.unmapMatchList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentUnmapMatchPage = 1;
      this.getUnmapMatchList();
    },
    changedPage: function(pageNo) {
      this.currentUnmapMatchPage = pageNo;
      this.getUnmapMatchList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>